<template>
  
  <div class="m-4">
        
        <div class="flex w-full items-center justify-center bg-grey-lighter">
            <label class="w-full flex flex-col items-center px-4 py-6 bg-white text-blue-500 rounded-lg shadow-lg tracking-wide uppercase border border-blue-500 cursor-pointer hover:bg-blue-500 hover:text-white">
                <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                </svg>
                <span class="mt-2 text-base leading-normal">Upload Arquivo</span>
                <input type="file" class="hidden" id="file" ref="file" v-on:change="handleFileUpload()"/>
            </label>
        </div>

        <div class="w-full" v-if="progressBar">
          <div class="shadow w-full bg-grey-light">
            <transition name="slide">
              <div class="bg-green-500 text-xs leading-none py-1 text-center text-white mt-1" :style="'width: '+percentage+'%'">{{percentage}}%</div>
            </transition>
          </div>
        </div>
        
  </div> 
    
</template>
<script>
import axios from 'axios';

export default {
    name: 'filePicker',
    data() {
           return {
             file:"",
             percentage:0,
             progressBar:false,
             filePublicId:""
         };
    },
    created: function() {   
        
    },
    watch:{
        filePublicId: function(newValue,oldValue)
        {
            this.$emit("uploadFinished", newValue);
        }
    },
    methods:{
       submitFile(){
        var that = this;
            that.progressBar = true;
            let formData = new FormData();

            formData.append('file', this.file);
            formData.append('upload_preset', "ondnt94i");

              let config = {
                  onUploadProgress: progressEvent => {
                    let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
                      that.percentage = percentCompleted;
                  },
                  headers: {
                      'Content-Type': 'multipart/form-data'
                  }
                }

              axios.post( 'https://api.cloudinary.com/v1_1/dimona/upload',formData,config
              ).then(function(result){
              that.filePublicId = result.data.public_id.replace("/",":");
              that.progressBar = false;
          })
          .catch(function(error){
            that.progressBar = false;
          });

          return false;
      },

      /*
        Handles a change on the file upload
      */
      handleFileUpload(){
        this.file = this.$refs.file.files[0];
        this.submitFile();
      }
    }
}
  
</script>

<style type="text/css">
  .slide-enter-active {
    transition: all .3s ease;
  }
  .slide-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-enter, .slide-leave-to
  /* .slide-fade-leave-active em versões anteriores a 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/filePicker.vue